// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f36e1f91","667":"38c2ce1a","977":"f81b90f5"}[chunkId] + ".chunk.js";
};